import { OverwriteCSSProperties, StandardCSSProperties } from '../types.js';
import {
  twBorders,
  twDisplay,
  twFlex,
  twOverflow,
  twShadows,
  twZIndex,
} from './constants.js';
import { stringOrNumberDefined } from './string-or-number-defined.js';

export const overwrites: Record<
  keyof OverwriteCSSProperties,
  (value: string | number) => {
    className?: string;
    style?: StandardCSSProperties;
  }
> = {
  border: (value) =>
    stringOrNumberDefined(value, 'border', (val) =>
      twBorders[val]
        ? {
            className: twBorders[val],
          }
        : {
            style: {
              border: `${val}px solid black`,
            },
          },
    ),
  boxShadow: (value) =>
    stringOrNumberDefined(value, 'boxShadow', (val) =>
      twShadows[val]
        ? {
            className: twShadows[val],
          }
        : {
            style: {
              // JUST FOR TESTING
              boxShadow: `0px 0px ${val}px rgba(0, 0, 0, 0.1)`,
            },
          },
    ),
  fontWeight: (value) => {
    if (typeof value === 'number') {
      return {
        style: {
          fontWeight: value,
        },
      };
    }
    switch (value) {
      case 'fontWeightLight':
      case 'light':
        return {
          className: 'font-light',
        };
      case 'fontWeightRegular':
      case 'regular':
        return {
          className: 'font-normal',
        };
      case 'fontWeightMedium':
      case 'medium':
        return {
          className: 'font-medium',
        };
      case 'fontWeightBold':
      case 'bold':
        return {
          className: 'font-bold',
        };
      default:
        return {
          style: {
            fontWeight: value,
          },
        };
    }
  },
  zIndex: (value) =>
    twZIndex[value as keyof typeof twZIndex]
      ? {
          className: twZIndex[value as keyof typeof twZIndex],
        }
      : {
          style: {
            zIndex: value,
          },
        },

  display: (value) => {
    const strValue = String(value);
    return twDisplay[strValue]
      ? { className: twDisplay[strValue] }
      : { style: { display: strValue } };
  },

  flex: (value) => {
    const key = typeof value === 'number' ? value : String(value);
    return twFlex[key]
      ? { className: twFlex[key] }
      : { style: { flex: value } };
  },

  overflow: (value) => {
    const strValue = String(value);
    return twOverflow[strValue]
      ? { className: twOverflow[strValue] }
      : { style: { overflow: strValue } };
  },
};
export const overwritesKeys = Object.keys(overwrites) as (
  | keyof OverwriteCSSProperties
  | 'borderRadius'
)[];
